import { forwardRef, PropsWithoutRef } from 'react';
import { createSafeContext } from '@mews-framework/utils';
import { FeatureFlagService } from './featureFlagService';

const { FeatureFlagServiceContextProvider, FeatureFlagServiceContextConsumer, useFeatureFlagServiceContext } =
    createSafeContext<'FeatureFlagServiceContext', FeatureFlagService>('FeatureFlagServiceContext');

export interface FeatureFlagServiceProps {
    featureFlagService: FeatureFlagService;
}

export const useFeatureFlag = (flagName: string) => useFeatureFlagServiceContext().hasFlag(flagName);
export const useFeatureFlagValue = (flagName: string) => useFeatureFlagServiceContext().getFlagValue(flagName);
export const useFeatureFlagService = useFeatureFlagServiceContext;

export const createFeatureFlagServiceProvider =
    (featureFlagService: FeatureFlagService) =>
    ({ children }: { children: React.ReactNode }) => (
        <FeatureFlagServiceContextProvider value={featureFlagService}>{children}</FeatureFlagServiceContextProvider>
    );

export const withFeatureFlagService = <P,>(Component: React.ComponentType<P & FeatureFlagServiceProps>) =>
    forwardRef((props: PropsWithoutRef<P>, ref) => (
        <FeatureFlagServiceContextConsumer>
            {(featureFlagService) => <Component {...(props as P)} featureFlagService={featureFlagService} ref={ref} />}
        </FeatureFlagServiceContextConsumer>
    ));
